var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00454 9.82098L3.00452 9.821C2.04648 10.7794 1.51797 12.0541 1.51797 13.409C1.51797 16.2069 3.7942 18.4832 6.59219 18.4832C7.94812 18.4832 9.22251 17.9551 10.1799 16.9969L16.998 10.1792L16.998 10.1792C17.956 9.22077 18.4846 7.94604 18.4846 6.59081C18.4845 3.79286 16.2083 1.51663 13.4103 1.51663C12.0544 1.51663 10.78 2.04475 9.82264 3.00289L3.00454 9.82098ZM9.43206 16.2492L9.43203 16.2492C8.67374 17.0079 7.66582 17.4256 6.59219 17.4256C4.37788 17.4256 2.57556 15.6236 2.57556 13.409C2.57556 12.3361 2.99327 11.3278 3.75232 10.5687L6.7875 7.53356L12.4673 13.2141L9.43206 16.2492ZM13.2151 12.4664L7.53524 6.78578L10.5704 3.75059L10.5705 3.75057C11.3287 2.99193 12.3367 2.57419 13.4103 2.57419C15.6246 2.57419 17.427 4.3762 17.427 6.59085C17.427 7.66408 17.0092 8.67241 16.2502 9.43146L13.2151 12.4664Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.950a58d6c41bf696dd0058d8c17a2ba5.svg";
export { ForwardRef as ReactComponent };